/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react';
import {
  Grid,
  Typography,
  MenuList,
  MenuItem,
  RACButton,
  RACSelect,
} from '@rentacenter/racstrap';
import clsx from 'clsx';
import { headerStyles } from '../../headerStyles';
import userImage from '../../assets/images/standard icon.png';
// import OutsideClickHandler from 'react-outside-click-handler';
import { ReactComponent as CloseIcon } from '../../assets/images/close_icon_2.svg';
import { useAuthContext } from '../../context/auth/auth-context';
import { MenuContext } from '../../context/menuContext';
import {
  ChangeLanguageAction,
  GetStoreChangeAction,
} from '../../context/global/store/store-action';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGlobalDispatchContext } from '../../context/global/global-context';
// import { ChangeLanguageAction } from '../../context/global/store/store-action';

export const UserComponent = (props: any) => {
  const classes = headerStyles();
  // const history = useHistory();
  const { logout } = useAuthContext();
  const dispatch: any = useGlobalDispatchContext();
  const language = window.sessionStorage.getItem('language')
  const {
    enableLanguageDropdown,
    setToggleSpanish,
    storeDetails,
    selectedLang,
    setSelectedLang,
  } = useContext(MenuContext);
  const { toggleSpanish } = useContext(MenuContext);

  /* eslint-disable @typescript-eslint/no-unused-vars */
  const [langOptions, setlangOptions] = useState<any>([
    { value: 'english', label: 'English' },
    { value: 'spanish', label: language === 'es-MX'? 'Spanish' :'Español' },
  ]);

  const { t } = useTranslation();

  const history = useHistory();
  const [hideShowProfile, showProfile] = useState('');

  useEffect(() => {
    setToggleSpanish(
      window.sessionStorage.getItem('language') == 'es-US' ||
        window.sessionStorage.getItem('language') == 'es-MX'
        ? true
        : false
    );
    // if (enableLanguageDropdown && selectedLang == '' ) {
    //   debugger
    //   setSelectedLang(
    //     window.sessionStorage.getItem('language') == 'es-US' ||
    //       window.sessionStorage.getItem('language') == 'es-MX'
    //       ? 'spanish'
    //       : 'english'
    //   );
    // } else {
    //   setSelectedLang('');
    // }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enableLanguageDropdown]);

  useEffect(() => {
    const storeNumber: any = window.sessionStorage.getItem('storeNumber');
    dispatch(GetStoreChangeAction(storeNumber));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toggleSpanish]);

  const Profile = () => {
    hideShowProfile == '' ? showProfile('show') : showProfile('');
  };

  const languageToggleOnChange = async (value: any) => {
    const storeNumber: any = window.sessionStorage.getItem('storeNumber');
    setSelectedLang(value);

    if (value == 'spanish') {
      const filteredUnits =
        storeDetails &&
        storeDetails.filter(
          (unit: any) => unit.accountingUnitNumber == storeNumber
        );
      window.sessionStorage.setItem(
        'language',
        filteredUnits[0]?.storeDetails?.country == 'MX' ? 'es-MX' : 'es-US'
      );
    } else {
      window.sessionStorage.setItem('language', 'en');
    }
    const language: any = window.sessionStorage.getItem('language');
    dispatch(GetStoreChangeAction(storeNumber));
    dispatch(ChangeLanguageAction(language));
    // dispatch(getCurrentUserThunk(dispatch))

    history.push(props.initialPath);
  };
  return (
    <Grid
      className={classes.racDropdown}
      data-testid="profilebtn"
      onClick={Profile}
    >
      <a
        data-testid="logoutbtn"
        className={hideShowProfile === 'show' ? 'racUser show' : 'racUser'}
        id="profilemenu"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <img
          className={classes.racStandardIcon}
          src={userImage}
          alt="search-icon"
        />
      </a>
      {/* <OutsideClickHandler onOutsideClick={() => showProfile('')}> */}
      <MenuList
        data-testid="logouttest"
        className={clsx({
          [classes.racGlobalSearchShow]: hideShowProfile === 'show',
        })}
        classes={{
          root: clsx(
            classes.racProfileContent,
            classes.racProfileMenu,
            classes.menuList
          ),
        }}
        aria-labelledby="profilemenu"
      >
        <MenuItem
          className={`${classes.menuItem} ${classes.cursorDefault}`}
          disableRipple
          disableTouchRipple
        >
          <Grid container>
            <Grid item md={12}>
              <CloseIcon className={classes.closeIcon} />
            </Grid>
            <Grid item md={6}>
              <Typography>{t('First Name')}:</Typography>
            </Grid>
            <Grid item md={6}>
              <Typography>
                {props != undefined &&
                  props.userData != undefined &&
                  props.userData != {} &&
                  props.userData.firstName != undefined
                  ? props.userData.firstName
                  : ''}
              </Typography>
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem
          className={`${classes.menuItem} ${classes.cursorDefault}`}
          disableRipple
          disableTouchRipple
        >
          <Grid container>
            <Grid item md={6}>
              <Typography>{t('Last Name')}:</Typography>
            </Grid>
            <Grid item md={6}>
              <Typography>
                {props != undefined &&
                  props.userData != undefined &&
                  props.userData != {} &&
                  props.userData.lastName != undefined
                  ? props.userData.lastName
                  : ''}
              </Typography>
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem
          className={`${classes.menuItem} ${classes.cursorDefault}`}
          disableRipple
          disableTouchRipple
        >
          <Grid container>
            <Grid item md={6}>
              <Typography>{t('Email ID')}:</Typography>
            </Grid>
            <Grid item md={6}>
              <Typography>
                {props != undefined &&
                  props.userData != undefined &&
                  props.userData != {} &&
                  props.userData.email != undefined
                  ? props.userData.email
                  : ''}
              </Typography>
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem
          className={`${classes.menuItem} ${classes.cursorDefault}`}
          disableRipple
          disableTouchRipple
        >
          {enableLanguageDropdown && (
            <Grid container>
              <Grid item md={6}>
                <Typography>{t('Language')}:</Typography>
              </Grid>
              <Grid item md={6}>
                <RACSelect
                  options={langOptions}
                  defaultValue={selectedLang}
                  onChange={(e: any) => {
                    languageToggleOnChange(e.target.value);
                  }}
                  isDisabled={false}
                />
              </Grid>
            </Grid>
          )}
        </MenuItem>
        {props != undefined &&
          props.userRole != undefined &&
          props.userRole != '' ? (
          <MenuItem
            className={`${classes.menuItem} ${classes.cursorDefault}`}
            disableRipple
            disableTouchRipple
          >
            <Grid container>
              <Grid item md={6}>
                <Typography>{t('Role:')}</Typography>
              </Grid>
              <Grid item md={6}>
                <Typography>
                  {props != undefined && props.userRole != undefined
                    ? props.userRole
                    : ''}
                </Typography>
              </Grid>
            </Grid>
          </MenuItem>
        ) : null}
        <Grid container>
          <Grid
            item
            md={12}
            style={{ justifyContent: 'center', textAlign: 'center' }}
          >
            <RACButton color="primary" variant="contained" onClick={logout}>
              {t('Logout')}
            </RACButton>
          </Grid>
        </Grid>
      </MenuList>
      {/* </OutsideClickHandler> */}
    </Grid>
  );
};
